import React from "react";
import styled, { css } from "styled-components";

import { IViewProps, View } from "core/decorators/View";
import { toBlockCss } from "../common/BlockStylesConfig";
import { toTypographyCss } from "../common/TypographyStylesConfig";
import WrapperDivConfig from "./WrapperDivConfig";

interface IWrapperProps {
	config: WrapperDivConfig;
}

const StyledBlock = styled.div<IWrapperProps>(
	({config}: IWrapperProps) => css`
	margin: ${config.margin};
	padding: ${config.padding};`
);

export enum WrapperVariant {
	DEFAULT = "default",
}

interface IWrapperViewProps extends IViewProps<WrapperDivConfig, WrapperVariant> {
	className?: string;
	style?: React.CSSProperties;
}

@View({

	id: "wrapper-div",

	configClass: WrapperDivConfig,

	variants: WrapperVariant,

	// work in progress...
	preview: ({config, name}) => {

		return (
			<StyledBlock config={config}>
				{name || "Untitled Variant"}
			</StyledBlock>
		);
	}

})
export class WrapperDivView extends React.PureComponent<IWrapperViewProps> {

	public render() {
		return (
			<StyledBlock config={this.props.config} className={this.props.className} style={this.props.style}>
				{this.props.children}
			</StyledBlock>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/views/wrapperDiv/WrapperDiv.view.tsx